import { inject, Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BannerSettings } from './banner.types';

export interface BannerPickerResult {
  url: string;
}

@Injectable({
  providedIn: 'root',
})
export class BannerPickerService {
  private modalService = inject(NgbModal);

  /**
   * Open the banner picker modal
   * @param currentSettings - Current banner settings to pre-select
   * @returns Promise that resolves with the uploaded banner URL, or undefined if cancelled
   */
  async pick(currentSettings?: BannerSettings): Promise<BannerPickerResult | undefined> {
    const { BannerPickerModalComponent } = await import('./banner-picker-modal/banner-picker-modal.component');

    const modalRef = this.modalService.open(BannerPickerModalComponent, {
      size: 'lg',
      centered: false,
    });

    modalRef.componentInstance.currentSettings = currentSettings;

    try {
      const result = await modalRef.result;
      return result as BannerPickerResult;
    } catch {
      // Modal was dismissed
      return undefined;
    }
  }
}
